import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import styles from './ListOfCities.module.scss'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import { City } from './City/City'
import AddCity from './modals/AddCity'
import Loader from 'components/UI/Loader/Loader'
import Pagination from 'components/UI/Pagination/Pagination'

const initPagination = {
  page: 1,
  limit: 10,
}

export const ListOfCities = ({ translate }) => {
  const [cities, setCities] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const fetchCities = () => {
    superAxiosRequest({
      method: 'get',
      link: 'integration/cities',
      crm: true,
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setCities(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchCities()
  }, [pagination])

  const addCity = () => {
    const ms = {
      modalBodyComponent: () => <AddCity />,
      button: 'Save',
      link: 'integration/cities',
      title: 'Добавить город',
      isResponsive: true,
      crm: true,
      onSubmitSuccess: () => {
        fetchCities()
      },
      valid: {
        name: 'required',
      },
    }

    asideModalStore.activity(ms, {})
  }

  const editCity = (city) => {
    const ms = {
      modalBodyComponent: () => <AddCity />,
      button: 'Сохранить',
      link: `integration/cities/${city?.id}`,
      title: 'Редактировать город',
      isCenter: true,
      is_put: true,
      crm: true,
      onSubmitSuccess: fetchCities,
      valid: {
        name: 'required',
      },
    }
    asideModalStore.activity(ms, city)
  }

  const deleteCity = (cityId) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the city?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `integration/cities/${cityId}`,
          crm: true,
        }
        superAxiosRequest(apiConf).then(() => {
          setCities((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== cityId),
          }))
        })
      }
    })
  }

  const action = (actionType, e, items) => {
    const actions = new Map([
      ['edit_city', () => editCity(items)],
      ['delete_city', () => deleteCity(items.id)],
    ])
    return actions.get(actionType)?.()
  }

  const menu = [
    { name: translate.edit, action: 'edit_city' },
    { name: translate.delete, action: 'delete_city' },
  ]

  return (
    <div className={styles.reasonsContainer}>
      <div className={styles.header}>
        <PageHeader title={translate.list_of_cities} />
        <div className={styles.settingsLocalization__box}>
          <HeaderAddButton title={translate.add_city} onClick={addCity} />
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <>
          {cities?.result?.length === 0 ? (
            <div className={styles.noReasons}>There are no added cities</div>
          ) : (
            cities?.result?.map((city, index) => (
              <City
                key={city.id}
                city={city}
                action={action}
                index={index}
                menu={menu}
              />
            ))
          )}
        </>
      )}
      <div className={styles.pagination}>
        {cities?._meta.count_items > 5 && (
          <Pagination
            limit={pagination.limit}
            count={cities._meta.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}
